// @flow

import * as React from 'react';
import { translate } from 'react-i18next';
import { Currency } from 'common/components/Number';
import Proposition from 'common/modules/proposition/domain/proposition';
import PropositionListing from 'common/modules/proposition/domain/propositionListing';
import { SRow, TableContent } from 'common/components/DataTable';
import SalesPropositionMenuItem from './SalesPropositionMenuItem';

type Props = {
  user: Object,
  proposition: PropositionListing,

  onClick: () => void,
  onChange: (proposition: Proposition) => void,

  t: any,
};

function SalesPropositionRow({ proposition, onClick, t, user, onChange }: Props) {
  const { reference, title, state, dateRange, salesman } = proposition;
  const totalCost = proposition.totalCost;
  const salesmanIsCurrentUser = salesman && user.email === salesman.email;
  const salesmanName = salesman ? salesman.name : '-';

  return (
    <SRow key={reference} onClick={onClick}>
      <TableContent>{dateRange ? t('date.standard', { value: dateRange.from }) : '-'}</TableContent>
      <TableContent>{title}</TableContent>
      <TableContent>{ totalCost !== undefined ? <Currency value={totalCost} /> : '-'}</TableContent>
      <TableContent>{salesmanIsCurrentUser ? t('you') : salesmanName}</TableContent>
      <TableContent>{proposition.getCustomerName()}</TableContent>
      <TableContent>{t('commonSales:' + state.toLowerCase())}</TableContent>
      <TableContent>
        <SalesPropositionMenuItem proposition={proposition} onChange={onChange} />
      </TableContent>
    </SRow>
  );
}

export default translate('sales', 'commonSales')(SalesPropositionRow);



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/proposition/SalesPropositionRow.js